import script from "./header-buttons.vue?vue&type=script&setup=true&lang=js"
export * from "./header-buttons.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__